export default __webpack_public_path__ + "static/bannerPubliMBPR-891eb4a202359f17f1a96fc32b24c45b.png";